
import { AddHabitDialog } from "@/components/AddHabitDialog";
import { ProgressIndicator } from "@/components/ProgressIndicator";
import { Habit } from "@/types/habit";

interface AddHabitSectionProps {
  habits: Habit[];
  onAddHabit: (habit: {
    title: string;
    emoji: string;
    totalDays: number;
    reward: string;
    priority: "high" | "medium" | "low";
    dailyTarget?: {
      value: number;
      unit: string;
    };
  }) => void;
}

export const AddHabitSection = ({ habits, onAddHabit }: AddHabitSectionProps) => {
  return (
    <div className="flex justify-between w-full">
      {/* Left side - Add New Habit button */}
      <div className="mt-[100px]">
        <AddHabitDialog onAdd={onAddHabit} />
      </div>
      
      {/* Right side - Progress indicator */}
      <div>
        <ProgressIndicator habits={habits} />
      </div>
    </div>
  );
};
